import BrightcoveVideo from '../shared/brightcove/';
import PropTypes from 'prop-types';
import React from 'react';

const Video = ({bcVideoRefId, title}) => {
  return bcVideoRefId ? (
    <div className="profile-video">
      <div className="embed-responsive embed-responsive-16by9">
        <BrightcoveVideo bcVideoRefId={bcVideoRefId} title={title} />
      </div>
      <div className="spacer-2"></div>
    </div>
  ) : null;
};

Video.propTypes = {
  bcVideoRefId: PropTypes.string
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/about/video.js